import {AbstractControl, ValidatorFn} from '@angular/forms'

export function ValidateDomain(allowedDomains: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!allowedDomains.includes(TrimDomain(control.value))) {
      return {
        validDomain: true
      }
    }
    return null
  }
}

function TrimDomain(str: string): string {
  return str?.substr(str.lastIndexOf('@') + 1)
}
